var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.848 13.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.527 11.643c0 .632-.514 1.146-1.145 1.146H.434V.44h8.948c.631 0 1.145.513 1.145 1.145zM9.382.088h-9.3V13.14h9.3a1.5 1.5 0 001.498-1.498V1.586A1.5 1.5 0 009.382.088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.207 2.36H4.46v.353h.747zM6.701 2.36h-.747v.353H6.7zM2.867 8.31h5.199v-.353h-5.2zM2.867 9.804h3.698v-.353H2.867zM2.867 6.87h5.199v-.353h-5.2zM5.58 4.79c.8 0 1.547-.436 1.95-1.139l-.306-.176c-.34.594-.97.962-1.644.962a1.903 1.903 0 01-1.643-.962l-.305.176a2.256 2.256 0 001.948 1.14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.6e2546e1.svg";
export { ForwardRef as ReactComponent };